export default __webpack_public_path__ + "static/media/gallery_07.d7789743.jpg";